(() => {
  const root = document.querySelector('[data-parent-hub]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';
  const storageKey = 'schoolsmart_parent_hub_v1';
  const form = root.querySelector('[data-profile-form]');
  const list = root.querySelector('[data-profile-list]');
  const empty = root.querySelector('[data-empty-state]');
  const count = root.querySelector('[data-profile-count]');
  const formTitle = root.querySelector('[data-form-title]');
  const cancel = root.querySelector('[data-cancel-edit]');
  const modal = root.querySelector('[data-product-modal]');
  const searchForm = root.querySelector('[data-product-search]');
  const searchResults = root.querySelector('[data-search-results]');
  const searchNote = root.querySelector('[data-search-note]');
  let selecting = null;
  let state = load();

  function load() {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey));
      const data = value && Array.isArray(value.profiles) ? value : { version: 2, profiles: [] };
      data.version = 2;
      data.profiles.forEach(profile => {
        profile.items = (profile.items || []).map(item => ({ ...item, status: item.status || (item.done ? 'got' : 'need'), product: item.product || null }));
      });
      return data;
    } catch (_) { return { version: 2, profiles: [] }; }
  }

  const save = () => localStorage.setItem(storageKey, JSON.stringify(state));
  const uid = () => `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
  const esc = value => String(value || '').replace(/[&<>'"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);
  const initials = name => String(name || '?').split(/\s+/).filter(Boolean).slice(0, 2).map(part => part[0]).join('').toUpperCase();
  const findProfile = id => state.profiles.find(entry => entry.id === id);

  function resetForm() {
    form.reset();
    form.elements.profile_id.value = '';
    formTitle.textContent = 'Add a child';
    root.querySelector('[data-save-profile]').textContent = 'Save profile';
    cancel.hidden = true;
  }

  function render() {
    const profiles = state.profiles;
    empty.hidden = profiles.length > 0;
    count.textContent = `${profiles.length} ${profiles.length === 1 ? 'profile' : 'profiles'}`;
    list.innerHTML = profiles.map(profile => {
      const items = profile.items || [];
      const complete = items.filter(item => item.status === 'already' || item.status === 'got').length;
      const percentage = items.length ? Math.round((complete / items.length) * 100) : 0;
      const need = items.filter(item => item.status === 'need');
      const unlinked = need.filter(item => !item.product?.variantId).length;
      const details = [profile.school, profile.year].filter(Boolean).map(esc).join(' • ') || 'No school or year saved';
      const itemRows = items.map(item => {
        const linked = item.product ? `${esc(item.product.title)} • ${esc(item.product.variantTitle)}` : 'No product and size selected';
        return `<li><div class="ss-ph-item-copy"><span>${esc(item.text)}</span><small class="ss-ph-linked">${linked}</small></div><div class="ss-ph-statuses" aria-label="Item status"><button type="button" data-set-status="${esc(item.id)}" data-profile-id="${esc(profile.id)}" data-status="need" aria-pressed="${item.status === 'need'}">Need</button><button type="button" data-set-status="${esc(item.id)}" data-profile-id="${esc(profile.id)}" data-status="already" aria-pressed="${item.status === 'already'}">Already got</button><button type="button" data-set-status="${esc(item.id)}" data-profile-id="${esc(profile.id)}" data-status="got" aria-pressed="${item.status === 'got'}">Got it</button></div><button class="ss-ph-pick" type="button" data-pick-product="${esc(item.id)}" data-profile-id="${esc(profile.id)}">${item.product ? 'Change product/size' : 'Choose product/size'}</button><button class="ss-ph-delete-item" type="button" data-delete-item="${esc(item.id)}" data-profile-id="${esc(profile.id)}" aria-label="Delete ${esc(item.text)}">×</button></li>`;
      }).join('');
      const shopNote = need.length === 0 ? 'Mark an item as Need to shop for it.' : unlinked ? `${unlinked} needed ${unlinked === 1 ? 'item needs' : 'items need'} a product and size selected.` : `${need.length} selected ${need.length === 1 ? 'item' : 'items'} ready for the basket.`;
      return `<article class="ss-ph-card"><div class="ss-ph-card-head"><span class="ss-ph-avatar">${esc(initials(profile.name))}</span><div class="ss-ph-card-title"><b>${esc(profile.name)}</b><small>${details}</small></div><div class="ss-ph-card-actions"><button type="button" data-edit-profile="${esc(profile.id)}">Edit</button><button class="is-delete" type="button" data-delete-profile="${esc(profile.id)}">Delete</button></div></div><div class="ss-ph-sizes"><div class="ss-ph-size"><small>Top size</small><b>${esc(profile.topSize || 'Not saved')}</b></div><div class="ss-ph-size"><small>Trouser/skirt</small><b>${esc(profile.bottomSize || 'Not saved')}</b></div><div class="ss-ph-size"><small>PE kit</small><b>${esc(profile.peSize || 'Not saved')}</b></div></div><div class="ss-ph-progress-wrap"><div class="ss-ph-progress-head"><span>Uniform progress</span><span>${complete} of ${items.length} complete • ${percentage}%</span></div><div class="ss-ph-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${percentage}"><span style="width:${percentage}%"></span></div></div><div class="ss-ph-list"><div class="ss-ph-list-head"><h4>Uniform list</h4><button class="ss-ph-shop" type="button" data-shop-now="${esc(profile.id)}" ${need.length === 0 ? 'disabled' : ''}>Shop now</button></div><p class="ss-ph-shop-note">${shopNote}</p><form class="ss-ph-item-form" data-item-form="${esc(profile.id)}"><input name="uniform_item" maxlength="80" required placeholder="e.g. 2 white polo shirts"><button type="submit">Add item</button></form><ul class="ss-ph-items">${itemRows || '<li><span>No items added yet.</span></li>'}</ul></div></article>`;
    }).join('');
  }

  form.addEventListener('submit', event => {
    event.preventDefault();
    const data = new FormData(form);
    const id = String(data.get('profile_id') || '');
    const profile = { id: id || uid(), name: String(data.get('name') || '').trim(), school: String(data.get('school') || '').trim(), year: String(data.get('year') || ''), topSize: String(data.get('top_size') || '').trim(), bottomSize: String(data.get('bottom_size') || '').trim(), peSize: String(data.get('pe_size') || '').trim(), items: id ? (findProfile(id)?.items || []) : [] };
    if (!profile.name) return;
    const index = state.profiles.findIndex(entry => entry.id === id);
    if (index >= 0) state.profiles[index] = profile; else state.profiles.push(profile);
    save(); resetForm(); render();
  });
  cancel.addEventListener('click', resetForm);

  root.addEventListener('submit', event => {
    const itemForm = event.target.closest('[data-item-form]');
    if (!itemForm) return;
    event.preventDefault();
    const profile = findProfile(itemForm.dataset.itemForm);
    const input = itemForm.querySelector('input[name="uniform_item"]');
    const text = input?.value.trim();
    if (!profile || !text) return;
    profile.items.push({ id: uid(), text, status: 'need', product: null });
    save(); render();
  });

  root.addEventListener('click', async event => {
    const status = event.target.closest('[data-set-status]');
    if (status) {
      const item = findProfile(status.dataset.profileId)?.items.find(entry => entry.id === status.dataset.setStatus);
      if (item) { item.status = status.dataset.status; save(); render(); }
      return;
    }
    const picker = event.target.closest('[data-pick-product]');
    if (picker) {
      selecting = { profileId: picker.dataset.profileId, itemId: picker.dataset.pickProduct };
      const item = findProfile(selecting.profileId)?.items.find(entry => entry.id === selecting.itemId);
      modal.hidden = false; document.body.style.overflow = 'hidden';
      searchForm.elements.query.value = item?.text || '';
      searchResults.innerHTML = '';
      searchNote.textContent = 'Search your SchoolSmart catalogue, then choose a product and its correct size.';
      searchForm.elements.query.focus();
      return;
    }
    if (event.target.closest('[data-close-product]')) { closeModal(); return; }
    const choose = event.target.closest('[data-choose-variant]');
    if (choose) {
      const result = choose.closest('[data-result]');
      const select = result.querySelector('select');
      const option = select.selectedOptions[0];
      const item = findProfile(selecting.profileId)?.items.find(entry => entry.id === selecting.itemId);
      if (item && option?.value) {
        item.product = { variantId: Number(option.value), variantTitle: option.dataset.title, title: result.dataset.title, handle: result.dataset.handle };
        item.status = 'need'; save(); closeModal(); render();
      }
      return;
    }
    const shop = event.target.closest('[data-shop-now]');
    if (shop) { await shopNow(shop.dataset.shopNow, shop); return; }
    const edit = event.target.closest('[data-edit-profile]');
    if (edit) {
      const profile = findProfile(edit.dataset.editProfile); if (!profile) return;
      form.elements.profile_id.value = profile.id; form.elements.name.value = profile.name; form.elements.school.value = profile.school || ''; form.elements.year.value = profile.year || ''; form.elements.top_size.value = profile.topSize || ''; form.elements.bottom_size.value = profile.bottomSize || ''; form.elements.pe_size.value = profile.peSize || '';
      formTitle.textContent = `Edit ${profile.name}`; root.querySelector('[data-save-profile]').textContent = 'Update profile'; cancel.hidden = false; form.scrollIntoView({ behavior: 'smooth', block: 'start' }); return;
    }
    const removeProfile = event.target.closest('[data-delete-profile]');
    if (removeProfile) {
      const profile = findProfile(removeProfile.dataset.deleteProfile);
      if (profile && confirm(`Delete ${profile.name}'s profile and uniform list from this device?`)) { state.profiles = state.profiles.filter(entry => entry.id !== profile.id); save(); resetForm(); render(); }
      return;
    }
    const removeItem = event.target.closest('[data-delete-item]');
    if (removeItem) {
      const profile = findProfile(removeItem.dataset.profileId);
      if (profile) { profile.items = profile.items.filter(item => item.id !== removeItem.dataset.deleteItem); save(); render(); }
    }
  });

  searchForm.addEventListener('submit', async event => {
    event.preventDefault();
    const query = searchForm.elements.query.value.trim(); if (!query) return;
    searchNote.textContent = 'Searching…'; searchResults.innerHTML = '';
    try {
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`);
      if (!response.ok) throw new Error('Search failed');
      const products = (await response.json()).resources?.results?.products || [];
      if (!products.length) { searchNote.textContent = 'No matching products found. Try a shorter search, such as “grey trousers”.'; return; }
      searchNote.textContent = 'Choose a product, then select the correct available size.';
      const details = await Promise.all(products.map(product => fetch(`/products/${product.handle}.js`).then(res => res.ok ? res.json() : null)));
      searchResults.innerHTML = details.filter(Boolean).map(product => {
        const variants = product.variants.filter(variant => variant.available).map(variant => `<option value="${variant.id}" data-title="${esc(variant.title)}">${esc(variant.title)} — ${formatMoney(variant.price)}</option>`).join('');
        return `<article class="ss-ph-result" data-result data-title="${esc(product.title)}" data-handle="${esc(product.handle)}"><img src="${esc(product.featured_image || '')}" alt=""><div><h3>${esc(product.title)}</h3>${variants ? `<div class="ss-ph-result-controls"><select aria-label="Choose size or option">${variants}</select><button type="button" data-choose-variant>Select</button></div>` : '<small>Currently unavailable</small>'}</div></article>`;
      }).join('');
    } catch (_) { searchNote.textContent = 'The product search could not load. Please try again.'; }
  });

  function closeModal() { modal.hidden = true; document.body.style.overflow = ''; selecting = null; }
  function formatMoney(pence) { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(Number(pence || 0) / 100); }
  async function shopNow(profileId, button) {
    const profile = findProfile(profileId);
    const needed = (profile?.items || []).filter(item => item.status === 'need');
    const linked = needed.filter(item => item.product?.variantId);
    if (!linked.length) { alert('Choose a product and size for each needed item first.'); return; }
    if (linked.length !== needed.length) { alert('Some needed items do not have a product and size selected yet. Select them before adding the list to the basket.'); return; }
    button.disabled = true; button.textContent = 'Adding…';
    try {
      const quantities = new Map();
      linked.forEach(item => quantities.set(item.product.variantId, (quantities.get(item.product.variantId) || 0) + 1));
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [...quantities].map(([id, quantity]) => ({ id, quantity })) }) });
      if (!response.ok) throw new Error('Cart error');
      window.location.href = '/cart';
    } catch (_) {
      button.disabled = false; button.textContent = 'Shop now';
      alert('The selected items could not be added. One of the sizes may have sold out—please check the product selections and try again.');
    }
  }
  render();
})();
